module.exports = __webpack_public_path__ + "img/task_attachment.4c245e92.svg";